function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.15,
  clipPath: "url(#mastercardbackground0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52.0995 28.7925C23.372 28.7925 0 52.1621 0 80.8871C0 109.612 23.372 132.982 52.0995 132.982C80.827 132.982 104.199 109.612 104.199 80.8871C104.199 52.1621 80.827 28.7925 52.0995 28.7925Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M109.9 28.7925C81.1728 28.7925 57.8008 52.1621 57.8008 80.8871C57.8008 109.612 81.1728 132.982 109.9 132.982C138.628 132.982 162 109.612 162 80.8871C162 52.1621 138.628 28.7925 109.9 28.7925Z",
  fill: "#FA8578"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.094 97.9834C78.094 95.3619 75.9694 93.2373 73.3479 93.2373H59.2852C60.0898 96.5349 61.2083 99.71 62.6087 102.729H73.3479C75.9694 102.729 78.094 100.605 78.094 97.9834Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M78.0926 67.0938C78.0926 64.4735 75.968 62.3477 73.3465 62.3477H61.2131C60.0513 65.3869 59.1651 68.5608 58.5879 71.8398H73.3465C75.968 71.8398 78.0926 69.7152 78.0926 67.0938Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.1495 82.5376C91.1495 79.9161 89.0237 77.7915 86.4034 77.7915H57.8947C57.8342 78.8161 57.8008 79.8469 57.8008 80.8863C57.8008 83.0518 57.9355 85.1863 58.1938 87.2837H86.4034C89.0237 87.2837 91.1495 85.1591 91.1495 82.5376Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "mastercardbackground0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 162,
  height: 162,
  fill: "white"
})));

var SvgMastercardBackground = function SvgMastercardBackground(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMastercardBackground, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mastercard-background.b86112f7.svg";
export { ForwardRef as ReactComponent };